import { apiClient } from './config';

interface GoogleAuthRequest {
  token: string;
  email: string;
  name: string;
}

interface AuthResponse {
  token: string;
  userId: number;
  name: string;
  email: string;
  organisationId: number;
}

export class AuthService {
  private static instance: AuthService;

  static getInstance(): AuthService {
    if (!AuthService.instance) {
      AuthService.instance = new AuthService();
    }
    return AuthService.instance;
  }

  async googleLogin(
    tokenId: string,
    email: string,
    name: string
  ): Promise<AuthResponse> {
    const request: GoogleAuthRequest = {
      token: tokenId,
      email,
      name,
    };

    const response = await apiClient.post<AuthResponse>(
      '/api/auth/google',
      request
    );
    return response.data;
  }
}
